let LegalEntityType = /*#__PURE__*/function (LegalEntityType) {
  LegalEntityType["Unknown"] = "UNKNOWN";
  LegalEntityType["Person"] = "PERSON";
  LegalEntityType["Company"] = "COMPANY";
  LegalEntityType["Association"] = "ASSOCIATION";
  return LegalEntityType;
}({});

export { LegalEntityType };
//# sourceMappingURL=legal-entity-type.js.map
